/* ==========================================================================
   mega-menu.js — Unified Shop menu behavior (§17 DOM contract)

   Drives the single .shop-drop at all breakpoints:
   - Desktop (≥769, hover:hover): click Shop toggles .shop-open; hovering a
     child-bearing category/browse link reveals its .tertiary (default Dine on
     open); clicking a category navigates (§13a). Childless links navigate.
   - Touch tablet (≥769, hover:none): tapping a child-bearing link reveals its
     tertiary and suppresses navigation; tertiary items / childless links nav.
   - Mobile (≤768): hamburger toggles .menu-open; tapping a child-bearing link
     drills its tertiary in; the back button returns to the list.

   Open-state classes live on .main-header: .shop-open (desktop) / .menu-open
   (mobile). Active panel + link carry .tertiary-open. current-page /
   related-hovered dimming is owned by nav-active.js.
   ========================================================================== */

(function () {
  'use strict';

  var header = document.querySelector('.main-header');
  var nav = document.getElementById('primary-nav');
  var drop = document.querySelector('[data-shop-drop]');
  if (!header || !nav || !drop) return;

  var shopToggle = header.querySelector('[data-shop-toggle]');
  var shopClose = drop.querySelector('[data-shop-close]');
  var hamburger = header.querySelector('.hamburger');

  var desktopMQ = window.matchMedia('(min-width: 769px)');
  var hoverMQ = window.matchMedia('(hover: hover)');
  function isDesktop() { return desktopMQ.matches; }
  function hasHover() { return hoverMQ.matches; }

  // ---------- tertiary reveal (one open globally, §13) ----------

  function clearTertiaries() {
    var open = drop.querySelectorAll('.tertiary-open');
    for (var i = 0; i < open.length; i++) {
      open[i].classList.remove('tertiary-open');
    }
  }

  // Resolve .tertiary[data-secondary-id=X][data-tertiary-id=Y] from the link's
  // matching pair (§17.5). Returns false for childless links (no tertiary-id).
  function revealTertiary(link) {
    var tid = link.getAttribute('data-tertiary-id');
    if (!tid) return false;
    var sid = link.getAttribute('data-secondary-id');
    var panel = drop.querySelector(
      '.tertiary[data-secondary-id="' + sid + '"][data-tertiary-id="' + tid + '"]'
    );
    clearTertiaries();
    if (panel) panel.classList.add('tertiary-open');
    link.classList.add('tertiary-open');
    return true;
  }

  // Default-Dine on desktop open (§4a/§13a) — once per open.
  function applyDefaultTertiary() {
    var dine = drop.querySelector('.secondary__link[data-tertiary-id="category-dine"]');
    if (dine) revealTertiary(dine);
  }

  // ---------- desktop open / close ----------

  function openShop() {
    header.classList.add('shop-open');
    if (shopToggle) shopToggle.setAttribute('aria-expanded', 'true');
    clearTertiaries();
    applyDefaultTertiary();
  }

  function closeShop() {
    header.classList.remove('shop-open');
    if (shopToggle) shopToggle.setAttribute('aria-expanded', 'false');
    clearTertiaries();
  }

  function toggleShop() {
    if (header.classList.contains('shop-open')) closeShop();
    else openShop();
  }

  // ---------- mobile overlay ----------

  function openMenu() {
    header.classList.add('menu-open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    header.classList.remove('menu-open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    clearTertiaries();
  }

  // ---------- wiring ----------

  if (shopToggle) {
    // The Shop link is a no-JS fallback to /collections/all. On desktop it
    // toggles the drop; on mobile its lists are already shown in the overlay,
    // so it acts as an inert section header. Either way: don't navigate.
    shopToggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (isDesktop()) toggleShop();
    });
  }

  if (shopClose) {
    shopClose.addEventListener('click', function (e) {
      e.preventDefault();
      closeShop();
    });
  }

  if (hamburger) {
    hamburger.addEventListener('click', function (e) {
      e.preventDefault();
      if (header.classList.contains('menu-open')) closeMenu();
      else openMenu();
    });
  }

  var secondaryLinks = drop.querySelectorAll('.secondary__link');
  for (var i = 0; i < secondaryLinks.length; i++) {
    bindSecondary(secondaryLinks[i]);
  }

  // Close the menu immediately when a leaf link is clicked so it doesn't look
  // stuck open during the full page load that follows (prod closes on leaf click, §2).
  function closeForNav() {
    if (isDesktop()) closeShop();
    else closeMenu();
  }

  function bindSecondary(link) {
    var hasChildren = link.hasAttribute('data-tertiary-id');

    // Desktop mouse: hover reveals; childless hover clears (§4/§13).
    link.addEventListener('mouseenter', function () {
      if (!isDesktop() || !hasHover()) return;
      if (hasChildren) revealTertiary(link);
      else clearTertiaries();
    });

    link.addEventListener('click', function (e) {
      if (!isDesktop()) {
        // Mobile: drill in if it has children; otherwise navigate + close.
        if (hasChildren) {
          e.preventDefault();
          revealTertiary(link);
        } else {
          closeForNav();
        }
        return;
      }
      if (hasHover()) {
        // Desktop mouse. Category links carry a real href → navigate (§13a):
        // close the drop and let the click through. Browse-by links are
        // href-less (prod parity) → inert: keep the menu open (their tertiary
        // was already revealed on hover), just suppress the dead click.
        if (link.getAttribute('href')) {
          closeForNav();
        } else {
          e.preventDefault();
        }
        return;
      }
      // Touch tablet (hover:none, ≥769): tap reveals, nav suppressed (§13a).
      if (hasChildren) {
        e.preventDefault();
        revealTertiary(link);
      } else {
        closeForNav();
      }
    });
  }

  // Leaf (tertiary) links always navigate → close the menu on click (§2 prod
  // parity). Navigation proceeds; we only clear the visual open state.
  var tertiaryLinks = drop.querySelectorAll('.tertiary__link');
  for (var t = 0; t < tertiaryLinks.length; t++) {
    tertiaryLinks[t].addEventListener('click', closeForNav);
  }

  // Mobile back button → return to the secondary list (§7).
  var backs = drop.querySelectorAll('[data-tertiary-back]');
  for (var b = 0; b < backs.length; b++) {
    backs[b].addEventListener('click', function (e) {
      e.preventDefault();
      clearTertiaries();
    });
  }

  // Escape closes (a11y divergence from prod, §11).
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (header.classList.contains('shop-open')) closeShop();
    if (header.classList.contains('menu-open')) closeMenu();
  });
})();
